import React from 'react';
import PropTypes from 'prop-types';
import CommonTabs from '../commonTabs';

const ClientsTab = ({ value }) => (
  <CommonTabs
    value={value}
    tabs={[
      { value: "international", labelId: "navbar.enterpriseinternational", to: "/external/clients-international" },
      { value: "france", labelId: "navbar.entreprisesfrance", to: "/external/companies" },
      { value: "onedata", labelId: "navbar.entreprisesonedata", to: "/external/clients-onedata" },
      { value: "exclusion", labelId: "navbar.enterprisesexclusion", to: "/external/clients-exclusion" },
      { value: "monitoring", labelId: "navbar.monitoring", to: "/external/monitoring" },
    ]}
  />
);

ClientsTab.propTypes = {
  value: PropTypes.any,
};

export default ClientsTab;
